export default __webpack_public_path__ + "static/media/feedback_try_02.ba6817d7.png";